const CANONICAL_ORIGIN = 'https://jidoka.ca';

// Default Firebase Hosting domains have their own storage (a separate login)
// and do not match authDomain. Preview channels
// (jidoka-voltera--<channel>-<hash>.web.app) are intentionally not listed.
const NON_CANONICAL_HOSTS = new Set(['jidoka-voltera.web.app', 'jidoka-voltera.firebaseapp.com']);

const redirectToCanonicalHost = (): boolean => {
  if (typeof window === 'undefined' || !NON_CANONICAL_HOSTS.has(window.location.hostname)) return false;
  const { pathname, search, hash } = window.location;
  window.location.replace(`${CANONICAL_ORIGIN}${pathname}${search}${hash}`);
  return true;
};

export const redirectingToCanonicalHost = redirectToCanonicalHost();
